import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { notify } from 'react-notify-toast'

import { dashboardConstants, uiConstants } from '../constants'
import { uiHelper } from '../helpers'

export function callSearch (payload) {
  return dispatch => {
    dispatch(doSearch())
    axios({
      method: 'POST',
      url: URIS.search,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(doSearchSuccess(res.data))
      if (res.data.list.length === 0) {
        notify.show('Nessun risultato', uiConstants.toast.warning, 3000)
      } else {
        dispatch(callImages(payload))
      }
    }).catch(error => {
      dispatch(doSearchFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
      // if (error.response !== undefined) { dispatch(doSearchFailure(error.response.statusText)) } else { dispatch(doSearchFailure(error.message)) }
    })
  }
}

function doSearch () {
  return {
    type: dashboardConstants.SEARCH
  }
}

function doSearchSuccess (payload) {
  return {
    type: dashboardConstants.SEARCH_SUCCESS,
    payload
  }
}

function doSearchFailure (payload) {
  return {
    type: dashboardConstants.SEARCH_FAILURE,
    payload
  }
}

export function callDetails (payload) {
  return dispatch => {
    dispatch(getSingle())
    axios({
      method: 'GET',
      url: URIS.search + `?id=${payload}`,
      headers: loadHeaders(),
      data: { id: payload }
    }).then(res => {
      dispatch(getSingleSuccess(res.data))
    }).catch(error => {
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
      if (error.response !== undefined) { dispatch(getSingleFailure(error.response.statusText)) } else { dispatch(getSingleFailure(error.message)) }
    })
  }
}

function getSingle () {
  return {
    type: dashboardConstants.GET_SINGLE
  }
}

function getSingleSuccess (payload) {
  return {
    type: dashboardConstants.GET_SINGLE_SUCCESS,
    payload
  }
}

function getSingleFailure (payload) {
  return {
    type: dashboardConstants.GET_SINGLE_FAILURE,
    payload
  }
}

export function saveHoleDetails (id, payload) {
  return dispatch => {
    dispatch(getSingle())
    axios({
      method: 'PUT',
      url: URIS.anomaly + `?id=${id}&a=info`,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(getSingleSuccess(res.data))
      notify.show('Informazioni salvate', uiConstants.toast.success, 3000)
    }).catch(error => {
      notify.show('Errore durante il salvataggio, riprovare', uiConstants.toast.error, 3000)
      if (error.response !== undefined) { dispatch(getSingleFailure(error.response.statusText)) } else { dispatch(getSingleFailure(error.message)) }
    })
  }
}

export function lockUnlock (id) {
  return dispatch => {
    dispatch(getSingle())
    axios({
      method: 'PUT',
      url: URIS.anomaly + `?id=${id}&a=lock`,
      headers: loadHeaders(),
      data: {}
    }).then(res => {
      dispatch(getSingleSuccess(res.data))
      notify.show('Nuovo stato anomalia salvato con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      notify.show('Errore durante il salvataggio, riprovare', uiConstants.toast.error, 3000)
      if (error.response !== undefined) { dispatch(getSingleFailure(error.response.statusText)) } else { dispatch(getSingleFailure(error.message)) }
    })
  }
}

export function saveFormFilters (payload) {
  return {
    type: dashboardConstants.SAVE_FORM_FILTERS,
    payload
  }
}

export function changeMapZoom (payload) {
  return {
    type: dashboardConstants.CHANGE_MAP_ZOOM,
    payload
  }
}

export function changeMapCenter (payload) {
  return {
    type: dashboardConstants.CHANGE_MAP_CENTER,
    payload
  }
}

export function changeClusterSize (payload) {
  return {
    type: dashboardConstants.CHANGE_CLUSTER_SIZE,
    payload
  }
}

export function massiveAssign (payload) {
  return dispatch => {
    dispatch(doMassive())
    axios({
      method: 'PUT',
      url: URIS.massive,
      headers: loadHeaders(),
      data: payload
    }).then(() => {
      dispatch(doMassiveSuccess())
      notify.show('Anomalie associate con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      notify.show('Errore durante associazione anomalie, riprovare', uiConstants.toast.error, 3000)
      if (error.response !== undefined) { dispatch(doMassiveFailure(error.response.statusText)) } else { dispatch(doMassiveFailure(error.message)) }
    })
  }
}

function doMassive () {
  return {
    type: dashboardConstants.MASSIVE
  }
}

function doMassiveSuccess (payload) {
  return {
    type: dashboardConstants.MASSIVE_SUCCESS,
    payload
  }
}

function doMassiveFailure (payload) {
  return {
    type: dashboardConstants.MASSIVE_FAILURE,
    payload
  }
}

export function callImages (payload) {
  return dispatch => {
    dispatch(doGetImages())
    axios({
      method: 'POST',
      url: URIS.images,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(doGetImagesSuccess(res.data))
    }).catch(error => {
      dispatch(doGetImagesFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
      // if (error.response !== undefined) { dispatch(doSearchFailure(error.response.statusText)) } else { dispatch(doSearchFailure(error.message)) }
    })
  }
}

function doGetImages () {
  return {
    type: dashboardConstants.GET_IMAGES
  }
}

function doGetImagesSuccess (payload) {
  return {
    type: dashboardConstants.GET_IMAGES_SUCCESS,
    payload
  }
}

function doGetImagesFailure (payload) {
  return {
    type: dashboardConstants.GET_IMAGES_FAILURE,
    payload
  }
}

export function resetImages () {
  return {
    type: dashboardConstants.RESET_IMAGES
  }
}

export function switchImageLayer () {
  return {
    type: dashboardConstants.SWITCH_IMAGE_LAYER
  }
}

export function switchHoleLayer () {
  return {
    type: dashboardConstants.SWITCH_HOLE_LAYER
  }
}

export function generateMission () {
  return {
    type: dashboardConstants.GENERATING_MISSION
  }
}

export function generateMissionSuccess () {
  return {
    type: dashboardConstants.GENERATING_MISSION_SUCCESS
  }
}

export function generateMissionFailure (payload) {
  notify.show(payload, uiConstants.toast.error, 3000)
  return {
    type: dashboardConstants.GENERATING_MISSION_FAILURE
  }
}

export function certifyPhoto (payload) {
  return dispatch => {
    dispatch(doCertifyPhoto())
    axios({
      method: 'PUT',
      url: URIS.images + '?do=c',
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(doCertifyPhotoSuccess(res.data))
      notify.show('Foto aggiornata con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      dispatch(doCertifyPhotoFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
    })
  }
}

function doCertifyPhoto () {
  return {
    type: dashboardConstants.CERTIFY_PHOTO
  }
}

function doCertifyPhotoSuccess (payload) {
  return {
    type: dashboardConstants.CERTIFY_PHOTO_SUCCESS,
    payload
  }
}

function doCertifyPhotoFailure (payload) {
  return {
    type: dashboardConstants.CERTIFY_PHOTO_FAILURE,
    payload
  }
}

export function toggleCertifiedPhotos () {
  return {
    type: dashboardConstants.TOGGLE_CERTIFIED_PHOTOS
  }
}

export function riparablePhoto (payload) {
  return dispatch => {
    dispatch(doRiparablePhoto())
    axios({
      method: 'PUT',
      url: URIS.images + '?do=r',
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(doRiparablePhotoSuccess(res.data))
      notify.show('Foto aggiornata con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      dispatch(doRiparablePhotoFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
    })
  }
}

function doRiparablePhoto () {
  return {
    type: dashboardConstants.RIPARABLE_PHOTO
  }
}

function doRiparablePhotoSuccess (payload) {
  return {
    type: dashboardConstants.RIPARABLE_PHOTO_SUCCESS,
    payload
  }
}

function doRiparablePhotoFailure (payload) {
  return {
    type: dashboardConstants.RIPARABLE_PHOTO_FAILURE,
    payload
  }
}

export function mustBeRepaired (id, payload) {
  return dispatch => {
    dispatch(mustBeRepairedLoading())
    axios({
      method: 'PUT',
      url: URIS.anomaly + `?id=${id}&a=mbr`,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(mustBeRepairedSuccess(res.data))
      notify.show('Anomalia aggiornata con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      dispatch(mustBeRepairedFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
    })
  }
}

function mustBeRepairedLoading () {
  return {
    type: dashboardConstants.MUST_BE_REPAIRED
  }
}

function mustBeRepairedSuccess (payload) {
  return {
    type: dashboardConstants.MUST_BE_REPAIRED_SUCCESS,
    payload
  }
}

function mustBeRepairedFailure (payload) {
  return {
    type: dashboardConstants.MUST_BE_REPAIRED_FAILURE,
    payload
  }
}

export function repairedPhoto (payload) {
  return dispatch => {
    dispatch(doRepairedPhoto())
    axios({
      method: 'PUT',
      url: URIS.images + '?do=d',
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(doRepairedPhotoSuccess(res.data))
      notify.show('Foto aggiornata con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      dispatch(doRepairedPhotoFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
    })
  }
}

function doRepairedPhoto () {
  return {
    type: dashboardConstants.RIPARABLE_PHOTO
  }
}

function doRepairedPhotoSuccess (payload) {
  return {
    type: dashboardConstants.RIPARABLE_PHOTO_SUCCESS,
    payload
  }
}

function doRepairedPhotoFailure (payload) {
  return {
    type: dashboardConstants.RIPARABLE_PHOTO_FAILURE,
    payload
  }
}
